import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 481440 693966"
    {...props}
  >
    <path
      d="M240705 8980 4150 362322l209746-156646v483290h53638V205676l209756 156646z"
      style={{
        fill: "#2b2a29",
        stroke: "#1c1b17",
        strokeWidth: 9999.79,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
